import * as XLSX from "xlsx";

class Export {
    static toExcel(data, name = 'export') {
        let c = Array.isArray(data);
        if (!c) {
            data = Object.entries(data).map((value => {
                return value[1];
            }));
        }
        const sheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, sheet, "Sheet");
        XLSX.writeFile(workbook, `${name}.xlsx`);
    }
}

export default Export;